module.exports = __webpack_public_path__ + "img/0.607a2d8b.png";